import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles<any>(theme =>
  createStyles({
    otpInput: {
      borderRadius: '4px',
      borderColor: STYLE.COLOR.STROKE_DEFAULT,
      borderWidth: '1px',
      color: `${STYLE.COLOR.TEXT1} !important`,
      '& .MuiOutlinedInput-root': {
        width: '100%',
        height: 'initial !important',
        aspectRatio: '1 / 1',
      },
      '& input': {
        fontSize: 24,
        fontWeight: 400,
        textAlign: 'center',
        padding: 0,
      },
      '& fieldset': {
        borderRadius: '4px',
        borderColor: STYLE.COLOR.STROKE_DEFAULT,
        '& legend': {
          width: '0px !important',
        },
      },
      '& .MuiOutlinedInput-root.Mui-error': {
        backgroundColor: `${STYLE.COLOR.ERROR_LIGHTER} !important`,
      },
      '& :hover': {
        '&:not(.Mui-error):not(.Mui-disabled)': {
          '& fieldset': {
            borderColor: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
          },
        },
      },
      '& .Mui-disabled': {
        opacity: 0.5,
        cursor: 'not-allowed !important',
        '& fieldset': {
          borderColor: `${STYLE.COLOR.STROKE_DEFAULT} !important`,
        },
        '& .MuiInputBase-input': {
          color: `${STYLE.COLOR.TEXT1} !important`,
        },
        '& .MuiInputLabel-root': {
          color: `${STYLE.COLOR.TEXT3} !important`,
        },
      },
    },
  }),
);
